var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container equity-container"},[_c('div',{staticClass:"equity-main"},[(_vm.equity=='bjx')?[_c('bjx')]:(_vm.equity=='tjx')?[_c('tjx')]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }